(function($) {

    $(".fancybox").fancybox({
        openEffect  : 'none',
        closeEffect : 'none'
    });

    $("a.foto_group").fancybox({
        openEffect  : 'none',
        closeEffect : 'none'
    });

    $('.album').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    $('.clamp2').each(function(index, element) {
        $clamp(element, { clamp: 2, useNativeClamp: true });
    });

    $('.sponsoren').bxSlider({
        slideWidth: 185,
        minSlides: 2,
        maxSlides: 5,
        moveSlides: 1,
        slideMargin: 24,
        pager: false,
        nextText: '<i class="icon-arrow-right"></i>',
        prevText: '<i class="icon-arrow-left"></i>',
        auto: true
    });


    $('select').customSelect();

    $('input').not('.pw-checkbox').iCheck();

})(jQuery);


(function($) {

    var field = $('#user_login');

    field.keyup(function() {
        if( field.val() != '') {
            $('.js-user_login').text( field.val().replace(/ /g,"-") );
        } else {
            $('.js-user_login').text( 'gebruikersnaam' );
        }
    });

})(jQuery);


(function($) {

    if ( $('input[type="search"]').val() == '') {
        $('.search-row').hide();
    }

    $('.toggle-search').click(function(event) {
        event.preventDefault();
        $('.search-row').slideToggle();
    });

})(jQuery);




(function($) {
    if( location.hash === '#message') {
        $('.container').show();
    }

    $('.toggle').click(function(event){
        $('.container').show();
    })

    $('.icon-close').click(function(event){
        $('.container').hide();
        parent.location.hash = '';
    })
})(jQuery);